export enum EventType {
    Alert = 'alert',
    SetTask = 'setTask',
    SetTimerComplete = 'setTimerComplete',
    SetTimer = 'setTimer',
    StartTimer = 'startTimer',
    StopTimer = 'stopTimer',
    ReloadTasks = 'reloadTasks',
}

export type EventPayload = {
    action: EventType.Alert,
    value: string
} | {
    action: EventType.SetTask,
    task: {
        index: number,
        completed: boolean,
    },
} | {
    action: EventType.SetTimer,
    minutes: number,
} | {
    action: EventType.SetTimerComplete,
    minutes: number,
} | {
    action: EventType.ReloadTasks,
} | {
    action: EventType.StartTimer,
} | {
    action: EventType.StopTimer,
}
